'use client'

import { Button } from '@/components/shared/ui/base/buttons/button'
import { FeaturedIcon } from '@/components/shared/ui/foundations/featured-icon/featured-icon'
import { ArrowLeft, SearchLg } from '@untitledui/icons'
import { useRouter } from 'next/navigation'

export default function NotFound() {
  const router = useRouter()

  return (
    <div className="bg-primary flex min-h-screen flex-1 items-center justify-center p-4">
      <div className="flex w-full max-w-120 flex-col items-center gap-8 text-center">
        <div className="flex flex-col items-center gap-5">
          <FeaturedIcon icon={SearchLg} color="brand" theme="light" size="xl" />
          <div className="flex flex-col gap-2">
            <span className="text-brand-secondary text-sm font-semibold">404 fout</span>
            <h1 className="text-primary lg:text-display-sm text-display-xs font-semibold">Pagina niet gevonden</h1>
            <p className="text-md text-tertiary">
              Sorry, de pagina die u zocht bestaat niet of is verplaatst. Excuses voor het ongemak.
            </p>
          </div>
        </div>

        <div className="flex flex-col-reverse gap-3 self-stretch sm:flex-row sm:justify-center sm:self-auto">
          <Button size="lg" iconLeading={ArrowLeft} onClick={() => router.back()}>
            Ga terug naar de vorige pagina
          </Button>
        </div>
      </div>
    </div>
  )
}
